/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';

export interface UserChildMemoControllerFindMemoByCenter$Params {
  childId: string;
  centerId: string;
  userId?: string;
}

export function userChildMemoControllerFindMemoByCenter(http: HttpClient, rootUrl: string, params: UserChildMemoControllerFindMemoByCenter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChildMemoDto>>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerFindMemoByCenter.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChildMemoDto>>;
    })
  );
}

userChildMemoControllerFindMemoByCenter.PATH = '/api/child-memo/user';
